var App = App || {};

App.WidgetCategory = (function ($) {
    'use strict';

    const BpsMobile = ["xs", "sm", "md"];
    
    function CompareInit(selector) {

        // set up checkboxes functionality on load and reset when browser is resized through breakpoints
        if (selector.find(".widget-category-compare-controls").length) {
            CompareCheckboxes(selector);
            $(document).on("enter-xs enter-sm enter-md enter-lg enter-xl enter-xxl", function () { CompareCheckboxes(selector) });
        }
    }

    function CompareCheckboxes(component) {

        var controls = component.find(".widget-category-compare-controls").find(".form-check-input");
        controls.on("change", function () {
            CompareCheckboxesUpdate(component);
        });

        const checkboxLimitsMax = CompareCheckboxesBasedOnBp().max;
        controls.prop("checked", false);
        controls.slice(0, checkboxLimitsMax).prop("checked", true);

        const controlPanel = controls.parents(".widget-category-compare-controls");
        if (controls.length <= checkboxLimitsMax) { controlPanel.hide(); }
        else { controlPanel.show(); }

        CompareCheckboxesUpdate(component);
    }

    function CompareCheckboxesUpdate(component) {

        const controls = component.find(".widget-category-compare-controls");
        const controlsLegend = controls.find("legend .dynamic-text");
        const controlsChecked = controls.find("input:checked");
        const controlsUnchecked = controls.find("input:not(:checked)");
        const columnsShown = [];

        // disable checkboxes to enforce minimum and maximum checked
        const checkboxLimits = CompareCheckboxesBasedOnBp();

        if (controlsChecked.length >= checkboxLimits.max) {
            controlsUnchecked.attr("disabled", true);
        }
        else {
            controlsUnchecked.attr("disabled", false);
        }
        if (controlsChecked.length <= checkboxLimits.min) {
            controlsChecked.attr("disabled", true);
        }
        else {
            controlsChecked.attr("disabled", false);
        }

        var legendText = ""
        var controlIndex = 1;
        
        controlsChecked.each(function () {
            // show/hide content based on checked controls
            columnsShown.push($(this).attr("id"));

            //update legend text to include selected columns
            if (controlIndex != 1) {
                if (controlIndex == controlsChecked.length) {
                    legendText += ", and ";
                } else {
                    legendText += ", "
                }
            }

            legendText += $(this).siblings(".input-label").text();

            controlIndex++;
        });

        legendText += " are selected.";
        controlsLegend.text(legendText)

        component.find("[data-controlledby]").each(function () {
            var control = $(this).attr("data-controlledby");
            if (columnsShown.includes(control)) { $(this).show(); }
            else { $(this).hide(); }
        });
    }

    function CompareCheckboxesBasedOnBp() {

        let result;

        switch (ZagBreakpoints.GetBreakpoint()) {
            case 'xxl': result = { max: 4, min: 2 }; break;
            case 'xl': result = { max: 4, min: 2 }; break;
            case 'lg': result = { max: 3, min: 2 }; break;
            case 'md': result = { max: 3, min: 2 }; break;
            default: result = { max: 2, min: 1 };
        }
        return result;

    }

    return {
        CompareInit: CompareInit
    };

})(jQuery);